import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { FormField } from 'rmwc/FormField';
import { ListDivider } from 'rmwc/List';
import {default as Reactsel} from 'react-select';
import StarRatings from 'react-star-ratings';
import { ListItemGraphic} from 'rmwc/List';
import ReactTooltip from 'react-tooltip'

class AboutCentaTPO extends Component {
	constructor(props) {
		super(props)
    	this.state = {
    		question: '',
    		activeDiv: 0
    	}
	}

	handleQuestion = (e, value) => {
		this.setState({activeDiv: value})
	}

	handleRegister = (e) => {
		this.props.history.push('/portal/app/tq_registration/TPO/new/0')
	}

	handleTPOJump = (e) => {
		this.props.history.push('/portal/app/user/about/tpo')
	}

	handleTQJump = (e) => {
		this.props.history.push('/portal/app/user/about/tq')
	}

	handleMCJump = (e) => {
		this.props.history.push('/portal/app/user/about/mc')
	}

	render() {
		let handleQuestion = this.handleQuestion
		let handleTPOJump = this.handleTPOJump
		let handleTQJump = this.handleTQJump
		let handleMCJump = this.handleMCJump
		let handleRegister = this.handleRegister
		let tpoLogo = 'https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/artifacts/TPO_mnemonic.png'

		return (
			<div>
				<Grid>
					<GridCell span = "2">
						<Button raised theme="secondary-bg on-secondary" onClick = {((e) => handleTPOJump(e))}>CENTA TPO</Button>
					</GridCell>
					<GridCell span = "3">
					</GridCell>
					<GridCell span = "2">
						<Button raised theme="secondary-bg on-secondary" onClick = {((e) => handleTQJump(e))}>CENTA TQ</Button>
					</GridCell>
					<GridCell span = "3">
					</GridCell>
					<GridCell span = "2">
						<Button raised theme="secondary-bg on-secondary" onClick = {((e) => handleMCJump(e))}>CENTA MC</Button>
					</GridCell>
					<GridCell span="12">
					</GridCell>
					<GridCell span="4">
					</GridCell>
					<GridCell span="4">
						<img className ="tpoLogo" src={tpoLogo} alt="logo" />
					</GridCell>
					<GridCell span="4">
					</GridCell>
					<GridCell span="5">
					</GridCell>
					<GridCell span="2">
						<Button raised theme="secondary-bg on-secondary" onClick = {((e) => handleRegister(e))}>Register</Button>
					</GridCell>
					<GridCell span="5">
					</GridCell>
					<div hidden>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 1))}>
								<Typography use="headline7"><b>What is CENTA TPO?</b></Typography>
								<div className={ this.state.activeDiv === 1 ? "showdiv" : "hidediv"} >
								  	<p>
								  		CENTA Teaching Professionals’ Olympiad (TPO) is a competition for teaching professionals which is relevant for both in-service and aspiring teachers as well as anyone interested in teaching. TPO innovatively assesses teaching practices through situation responses, bring teaching professionals the chance to demonstrate their expertise at an international level.
								  	</p>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 2))}>
								<Typography use="headline7"><b>Why should I take up the TPO?</b></Typography>
								<div className={ this.state.activeDiv === 2 ? "showdiv" : "hidediv"} >
								  	<p>
								  		You get the chance to:
								  		<ul>
								  			<li>Win rewards through a host of exciting prizes, including cash awards, international training opportunities and co-authoring a book;</li>
								  			<li>Get recognized at national and international level;</li>
								  			<li>Enjoy exclusive access to career/job and other opportunities with leading schools and organisations in CENTA's partner network;</li>
								  			<li>Experience professional development - through the testing of your competencies and detailed insights on your areas of strengths and development (through a Confidential Personalized Performance Report)</li>
								  		</ul>
								  	</p>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 3))}>
								<Typography use="headline7"><b>What is the format of the test?</b></Typography>
								<div className={ this.state.activeDiv === 3 ? "showdiv" : "hidediv"} >
								  	<ul>
							  			<li>Two-hour, objective type, only one correct answer, no negative marking.</li>
							  			<li>Four sections, totally 64 questions, 100 marks, no section-wise time limit, questions can be attempted in any order.</li>
							  			<li>Competencies tested are based on the CENTA Standards. Computer-based but with a very simple interface – knowledge of computers is not required.</li>
							  		</ul>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 4))}>
								<Typography use="headline7"><b>What is the syllabus of the test?</b></Typography>
								<div className={ this.state.activeDiv === 4 ? "showdiv" : "hidediv"} >
								  	<p>TPO is board-agnostic and applicable for all boards (CBSE, ICSE, State Boards, IB, IGCSE, etc.). However, the topics tested in the Subject Expertise section are broadly (but not exclusively) aligned to the NCERT curriculum. For all other sections, the questions focus on conceptual understanding of your respective subjects and application of pedagogical techniques.</p>
								</div>
							</Card>
						</GridCell>
						<GridCell span = "12">
							<Typography use="headline6"><i>CENTA Teaching Professionals’ Olympiad (TPO) - India</i></Typography>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 5))}>
								<Typography use="headline7"><b>When will the TPO be held?</b></Typography>
								<div className={ this.state.activeDiv === 5 ? "showdiv" : "hidediv"} >
								  	<p>CENTA TPO will be held on Saturday, 12 th December, 2020.</p>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 6))}>
								<Typography use="headline7"><b>Where can I take up the TPO?</b></Typography>
								<div className={ this.state.activeDiv === 6 ? "showdiv" : "hidediv"} >
								  	<p>You can take up the TPO in one of the test cities across India. Choose your state of residence/neighbouring state to see the list of available test cities. We will be adding more test cities in the coming days so please keep an eye on this space!<br />To see the complete list of cities, <a href = "https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/artifacts/TestCities_India.pdf" target="_blank" style={{cursor: 'pointer'}}>Click here.</a></p>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 7))}>
								<Typography use="headline7"><b>Which are subject tracks that I can take up the TPO in?</b></Typography>
								<div className={ this.state.activeDiv === 7 ? "showdiv" : "hidediv"} >
								  	<p>
								  		There are 25 subject track options which you can choose from. The tracks have been split into 4 categories: Primary, Middle School, Secondary School and Senior Secondary School.<br/>
								  		<br /><b>Primary (Grades 1 to 5):</b><br />
								  		Primary (Language, Maths and EVS) – available in 6 mediums (English, Hindi, Kannada, Marathi, Tamil and Telugu) <br />
								  		<br />
								  		<b>Middle School (Grades 6 to 8):</b>
								  		<ul>
								  			<li>English</li>
								  			<li>Maths</li>
								  			<li>Science</li>
								  			<li>Social Studies</li>
								  		</ul>
								  		The Middle School Maths and Science tracks are also available in Hindi Medium. <br />
								  		<br />
								  		<b>Secondary School (Grades 9 and 10):</b>
								  		<ul>
								  			<li>English</li>
								  			<li>Maths</li>
								  			<li>Physics</li>
								  			<li>Chemistry</li>
								  			<li>Biology</li>
								  		</ul>
								  		<br />
								  		<b>Senior Secondary School (Grades 11 and 12):</b>
								  		<ul>
								  			<li>English</li>
								  			<li>Maths</li>
								  			<li>Physics</li>
								  			<li>Chemistry</li>
								  			<li>Biology</li>
								  			<li>Economics</li>
								  		</ul>
								  	</p>
								</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 8))}>
								<Typography use="headline7"><b>Which all time-slots can I take up the TPO in?</b></Typography>
								<div className={ this.state.activeDiv === 8 ? "showdiv" : "hidediv"} >
							  		<p>
							  			The test is conducted in 3 time slots in India:
							  			<ul>
			 								<li>9 AM to 11 AM</li>
											<li>12 Noon to 2 PM</li>
											<li>3 PM to 5 PM</li>
										</ul>
										Some of the Subject Tracks may not be available in all the time slots (details in the registration form). Please register at the earliest to get the time slot of your preference.
									</p>
							  	</div>
							</Card>
						</GridCell>
						<GridCell span="12">
							<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 9))}>
								<Typography use="headline7"><b>What is the registration fee?</b></Typography>
									<div className={ this.state.activeDiv === 9 ? "showdiv" : "hidediv"} >
								  		<p>
								  			The registration fee for CENTA TPO 2020 is INR 649 per subject track (inclusive of all taxes). <br/>
								  			<b>However, if you register before August 31 st , you can avail the special early bird registration fee of INR 590 (inclusive of taxes)!</b>
								  		</p>
								  	</div>
							</Card>
						</GridCell>
					</div>
				</Grid>
			</div>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutCentaTPO);


// WEBPACK FOOTER //
// ./src/views/about/AboutCentaTPO.jsx